<template>
    <div v-loading="loading">
        <headerpage :status="4"></headerpage>
        <div class="degro22und">
        <div class="adaptation" style="background-color: #f6f8f7;">
            <div class="hetext">首页>本地政策>详情</div>
            <div class="box" v-if="detail">
                <div> 
                    <div class="box_tt">{{detail.subtitle}}</div>
                    <div class="box_tt1"><span style="color: #9b9b9b;">发布时间：</span>{{detail.created_at}}</div>
                </div>
                <div style="padding:25px;">
                    <div class="box1">
                            <div class="box1_ttt">支持领域</div>
                            <div class="" v-html="detail.territory"></div>
                    </div>
                    <div class="box1">
                            <div class="box1_ttt">依据文件</div>
                            <div class="" v-html="detail.according"></div>
                    </div>
                    <div class="box1">
                            <div class="box1_ttt">最新动态</div>
                            <div class="" v-html="detail.content"></div>
                    </div>
                    <div class="box1">
                            <div class="box1_ttt">申报条件</div>
                            <div class="" v-html="detail.declare_condition"></div>
                    </div>
                    <div class="box1">
                            <div class="box1_ttt">支持力度</div>
                            <div class="text-center">
                            <!-- height="250"  -->
                            <el-table :data="detail.level" border style="width: 100%">
                            <el-table-column prop="index" align="center" label="序号"></el-table-column>
                            <el-table-column prop="level" align="center" label="支持等级"></el-table-column>
                            <el-table-column prop="factor" align="center" label="资助条件"></el-table-column>
                            <el-table-column prop="money" align="center" label="资助金额"></el-table-column>
                            <el-table-column label="参考文件" align="center">
                                <template slot-scope="scope">
                                <div class="cpoint" style="color: #0081ff;" @click="toout(scope.row.href)" :data-url="scope.row.href">{{scope.row.file}}</div>
                                </template>
                            </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                 
            </div>
        </div>
        <div style="height: 25px;"></div>
    </div>
     
    </div>
    
</template>
  
<script>
import headerpage from '../../components/header/header.vue';
import Nomore from '../../components/nomore.vue';
export default {
    components: {Nomore,headerpage },
    data() {
        return {
            detail:'',
            loading:true,
            id:''
        };
    },
    methods: {
        depotDetail(){
            this.loading= true
            this.$https.post(
                {
                    api: this.$api.api.index.depotDetail,
                    type: "formData",
                },
                {id:this.id},
                (response) => {
                    for(let i in response.data.level){
                            response.data.level[i]['index'] = Number(i)+1;
                        }
                    this.detail =  response.data
                    this.loading = false
                },
                (error) => {
                    console.log(error);
                }
            );
        },
    },
    created: function () {
        this.id = this.$route.query.id;
        this.depotDetail()
    },
}
</script>
<style>
.degro22und img{
    max-width: 100% !important;
}
 
</style>
<style scoped>
 
.hetext {
    font-size: 15px;
    color: #bdbdbd;
    padding: 16px 0;
    cursor: pointer;
}
.box{
    padding: 25px 20px;
    background-color: #ffffff;
	border-radius: 10px;
}
.box_tt{
    font-size: 20px;
    color: #171717;
    font-weight: 600;
    text-align: center;
}
.box_tt1{
    font-size: 15px;
    color: #525252;
    margin-top: 20px;
    text-align: center;
}
.box1{
    width: 80%;
    margin: 0 auto;
    padding: 30px;
    border: 1px solid #0170c1;
    border-radius: 10px;
    position: relative;
    margin-bottom: 25px;
    font-size: 22px;
    line-height: 36px;
    color: #737373;
}
.box1:last-child{
    margin-bottom: 0;
}
.box1_ttt{
    height: 30px;
    width:80px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    background-color: #0170c1;
    border-radius: 20px;
    position: absolute;
    top: -15px;
    font-size: 15px;
}
</style>
  
  


// WEBPACK FOOTER //
// policydetail.vue?3bf9dfa6